import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createLabourCostItem,
  getAllLabourCostItems,
  getDataForEdit,
  updateLabourCostItem,
  deleteLabourCostItem,
} from "../../store/LabourCost/LabourCostApi";
import { getAllFactoryItems } from "../../store/AppLevelApi/AppLevelApi";
import { labourCostSliceAction } from "../../store/LabourCost/LabourCost";
import { headTitle } from "../../utility/GetTableListName";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsLabourCost } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialLabourCostFormData } from "../../ConstantData/InitialData";
import { ErrorLabourCostFormData } from "../../ConstantData/ErrorOption";
function LabourCost() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllLabourCostItems()); //initial list data
    // dispatch(getAllFactoryItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const labourCostList = useSelector(
    (state) => state.labourcost.labourCostList
  ); //store user list

  const InitialFormDataStore = useSelector(
    (state) => state.labourcost.initialData
  );
  const labourCostEditData = useSelector((state) => state.labourcost.dataEdit);
  const factoryList = useSelector((state) => state.applevel.factoryList);
  let labourCostFormError = useSelector((state) => state.labourcost.errorData);
  let isError = useSelector((state) => state.labourcost.isError);
  labourCostFormError = { ...ErrorLabourCostFormData, ...labourCostFormError };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsLabourCost));
  if (factoryList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsLabourCost.map((item) => {
      if (item?.labelName === "Factory") {
        item.options = factoryList;
      }
      return item;
    });
  }
  const headTitleLabel = headTitle(FormOptionsLabourCost, [
    "Job Title",
    "Factory",
    "Number of Staff",
    "Average Cost",
    "Total",
  ]); //array is field that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialLabourCostFormData}
      createFun={createLabourCostItem} //create function coming from store
      updateFun={updateLabourCostItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteLabourCostItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create Labour Cost"
      OptionNameList="Labour Cost"
      generalList={labourCostList}
      headTitle={headTitleLabel}
      EditData={labourCostEditData}
      generalModuleList={factoryList} //list to add different module
      ErrorData={labourCostFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={labourCostSliceAction.setErrorData}
      isNotDeleteBtn={true}
      isSuccess={isSuccess}
    />
  );
}

export default LabourCost;
